import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHead, Btn, Card, Field, Select, Toggle, ImageUpload, AiCopyButton, AiSeoButton, SeoPreview } from "@/admin/ui";
import { toast } from "sonner";

const empty = () => ({ title: "", slug: "", category: "STYLE", excerpt: "", body: "", cover_image: "", published: true, seo: {} });

const JournalAdmin = () => {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const load = () => api.get("/admin/journal").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const up = (k, v) => setEditing((e) => ({ ...e, [k]: v }));

  const save = async () => {
    try {
      if (editing.id) await api.put(`/admin/journal/${editing.id}`, editing);
      else await api.post("/admin/journal", editing);
      toast.success("Saved"); setEditing(null); load();
    } catch { toast.error("Failed"); }
  };
  const del = async (id) => { if (!window.confirm("Delete article?")) return; await api.delete(`/admin/journal/${id}`); load(); };

  if (editing) return (
    <div className="max-w-2xl">
      <PageHead title={editing.id ? "Edit Article" : "New Article"}>
        <Btn variant="ghost" onClick={() => setEditing(null)}>Cancel</Btn>
        <Btn onClick={save} testid="admin-save">Save</Btn>
      </PageHead>
      <Card>
        <Field label="Title" value={editing.title} onChange={(v) => up("title", v)} />
        <Field label="Slug" value={editing.slug} onChange={(v) => up("slug", v)} placeholder="auto from title" />
        <Select label="Category" value={editing.category} onChange={(v) => up("category", v)} options={["STYLE", "CULTURE", "CRAFT", "LIFE"]} />
        <Toggle label="Published" value={editing.published} onChange={(v) => up("published", v)} />
        <ImageUpload label="Cover image" value={editing.cover_image} onChange={(v) => up("cover_image", v)} />
        <Field label="Excerpt" textarea value={editing.excerpt} onChange={(v) => up("excerpt", v)} />
        <AiCopyButton instruction={`Draft a Journal article body for "${editing.title || "a new piece"}" (category ${editing.category}).`} current={editing.body} onResult={(t) => up("body", t)} testid="journal-ai-draft" />
        <Field label="Body" textarea value={editing.body} onChange={(v) => up("body", v)} />
        <AiSeoButton subject={editing.title} context={editing.excerpt || editing.body} onResult={(d) => up("seo", { ...editing.seo, title: d.title, description: d.description })} testid="journal-ai-seo" />
        <Field label="SEO Title" value={editing.seo?.title} onChange={(v) => up("seo", { ...editing.seo, title: v })} />
        <Field label="SEO Description" textarea value={editing.seo?.description} onChange={(v) => up("seo", { ...editing.seo, description: v })} />
        <SeoPreview title={editing.seo?.title} description={editing.seo?.description} path={`/journal/${editing.slug || ""}`} />
      </Card>
    </div>
  );

  return (
    <div>
      <PageHead title="Journal" sub={`${items.length} articles`}>
        <Btn onClick={() => setEditing(empty())} testid="admin-new-article">+ New Article</Btn>
      </PageHead>
      <div className="bg-cream border border-espresso/10">
        {items.map((a) => (
          <div key={a.id} className="flex items-center gap-4 px-5 py-3 border-b border-espresso/5">
            <div className="flex-1">
              <p className="font-serif text-lg">{a.title}</p>
              <p className="text-xs text-espresso/50">{a.category} · {a.published ? "published" : "draft"}</p>
            </div>
            <Btn variant="ghost" onClick={() => setEditing(a)}>Edit</Btn>
            <button onClick={() => del(a.id)} className="text-wine text-xs tracking-widest uppercase">Delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JournalAdmin;
